import { Controller } from "@hotwired/stimulus"
import { turboFetch } from "../helpers/html_fetch"

export default class extends Controller {
  static targets = ["inStore", "inClan", "visibility"]
  static values = { previewUrl: String }

  previewVisibility() {
    const params = new URLSearchParams()

    params.append("creation[in_store]", this.inStoreTarget.checked)
    params.append("creation[in_clan]", this.inClanTarget.checked)
    params.append("creation[visibility]", this.#visibility)

    const url = `${this.previewUrlValue}?${params.toString()}`
    turboFetch(url)
  }

  get #visibility() {
    if (this.visibilityTarget.type == "hidden") {
      return this.visibilityTarget.value
    } else {
      return this.visibilityTargets.find(radio => radio.checked).value
    }
  }
}
